class CookieManager {
	constructor() {
		this.cookiesAvailable = this.checkCookiesEnabled();
		this.token = this.getCookie("token");
		this.reservationMenuId = this.getCookie("reservationMenuId");
		this.cookiesAccepted = this.getCookie("cookies-accepted") === "true";
	}

	checkCookiesEnabled() {
		try {
			document.cookie = "cookie-test=1; SameSite=Strict";
			const result = document.cookie.indexOf("cookie-test=") !== -1;
			document.cookie = "cookie-test=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			return result;
		} catch (e) {
			return false;
		}
	}

	hasConsent() {
		if (!this.cookiesAvailable) return false;
		return this.cookiesAccepted;
	}

	setConsent(value) {
		if (!this.cookiesAvailable) {
			console.warn("No se pueden guardar cookies: están bloqueadas por el navegador.");
			this.cookiesAccepted = value;
			return;
		}
		this.setCookie("cookies-accepted", value ? "true" : "false");
		this.cookiesAccepted = value;
	}

	clearConsent() {
		if (!this.cookiesAvailable) {
			this.cookiesAccepted = false;
			return;
		}
		this.clearCookie("cookies-accepted");
		this.cookiesAccepted = false;
	}

	setCookie(name, value) {
		if (!this.cookiesAvailable) {
			console.warn(`No se pueden guardar cookies. "${name}" no fue guardada.`);
			return;
		}
		if (name !== "cookies-accepted" && !this.hasConsent()) {
			console.warn(`No se pudo guardar la cookie "${name}" porque el usuario no ha aceptado las cookies.`);
			return;
		}
		const oneHundredYearsInSeconds = 100 * 365 * 24 * 60 * 60;
		const date = new Date();
		date.setTime(date.getTime() + oneHundredYearsInSeconds * 1000);
		const expires = "; expires=" + date.toUTCString();

		document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
	}

	getCookie(name) {
		if (!this.cookiesAvailable) return null;

		const nameEQ = encodeURIComponent(name) + "=";
		const ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i].trim();
			if (c.indexOf(nameEQ) === 0) {
				return decodeURIComponent(c.substring(nameEQ.length));
			}
		}
		return null;
	}

	clearCookie(name) {
		if (!this.cookiesAvailable) return;
		document.cookie = encodeURIComponent(name) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	}

	// Token methods
	getToken() {
		return this.token;
	}

	setToken(token) {
		this.setCookie("token", token);
		this.token = token;
	}

	clearToken() {
		this.clearCookie("token");
		this.token = "";
	}

	// ReservationMenuId methods
	getReservationMenuId() {
		return this.reservationMenuId;
	}

	setReservationMenuId(reservationMenuId) {
		this.setCookie("reservationMenuId", reservationMenuId);
		this.reservationMenuId = reservationMenuId;
	}

	clearReservationMenuId() {
		this.clearCookie("reservationMenuId");
		this.reservationMenuId = "";
	}
}

// Export cookie manager and consent event bus
export const cookieManager = new CookieManager();
export const cookieConsentBus = new EventTarget();
